<template>
  <div>
    <ElasticList
      :list.sync="casesList"
      :filter="caseMapFilter"
    />
  </div>
</template>
<script>
import Record from '@/mixins/Record';
import { API, graphqlOperation } from "aws-amplify";
import * as queries_custom from '@/graphql/queries_custom';
import moment from "moment";

export default {
  name: "casetab",
  mixins: [Record],
  props: {
    routeParamsId: {
      type: String,
      required: true
    },
    caseListData: {
      type: Object,
      required: true
    },
    caseMapFilter: {
      type: Object,
      required: false
    },
    caseServiceRelateRecordInput: {
      type: Object,
      required: false
    },
    defaultColumns: {
      type: Object,
      required: false,
      default: () => {
        return {
        'esData.case.createdAt': { label: "Created", sortable: true, esNested: true},
        'esData.case.subject': { label: "Subject", sortable: true, esNested: true },
        'esData.case.person': { label: "Person", sortable: false, searchable: true, display: true, esNested: true, nested: ["given_name", "family_name"] },
        'esData.case.quickNote': { label: "Quick Note", sortable: true, esNested: true },
        'esData.case.priority': { label: "Priority", sortable: false, esNested: true },
        'esData.case.closedDate': { label: "Closed", sortable: false, esNested: true},
        'esData.case.status': { label: "Status", sortable: false, esNested: true },
        'esData.service.name': { label: "Service", sortable: true, esNested: true },
        'esData.service.merchantNumber': { label: "MID", sortable: false, esNested: true },
        'esData.case.user': { label: "Assignee", sortable: false, display: true, esNested: true, nested: ["given_name", "family_name"]  },
        'esData.case.team.name': { label: "Team", sortable: false, searchable: true, display: true,  esNested: true },
        'esData.case.template.subject': { label: "Type", sortable: false, searchable: true, display: true,  esNested: true }
        };
      }
    }
  },
  data() {
    return {
      casesList: {
          hideNewRecordButton: false,
          refreshData: false,
          itemActions: [
            {
              class: "md-just-icon md-warning md-simple",
              icon: "description",
              click: "handleEdit"
            },
            {
              class: "md-just-icon md-danger md-simple",
              icon: "close",
              click: "handleDelete"
            }
          ],
          editPath: "cases",
          linkRows: true,
          pageTitle: "Cases",
          pageIcon: "how_to_vote",
          listQueryId: this.caseListData.listQueryId,
          responseFieldName: this.caseListData.responseFieldName,
          listQueryTarget: this.caseListData.listQueryTarget,
          deleteQueryId: this.caseListData.deleteQueryId,
          deleteQueryIdField: "relateRecordId",
          deleteMessageTitle: "Are you sure you want to remove {objectName} from this "+this.caseListData.caseFromTab+"?",
          deleteMessageText: "",
          deleteMessageNameFields: ['subject'],
          columns: this.caseListData.columns ? this.caseListData.columns :this.defaultColumns,
          currentSort: "createdAt",
          currentSortOrder: "asc",
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            perPage: 10,
          },
          addonFilters: [
            {
              id: 'esData.case.status',
              query: 'listCaseStatusEnum',
              queryOptionsKey: 'enumValues',
              key: 'name',
              label: 'name',
              placeholder: 'Status',
              modal: '',
              value: '',
            },
          ],
          columnFilter: {
            showFilter: true,
            columnName: 'Status',
            columnFilterList: [],
            sourceData: [],
            filterListQueryId: 'getListCaseStatusEnum'
          },
          pagination: {
            perPage: 25,
            currentPage: 1,
            perPageOptions: [5, 10, 25, 50],
            total: 0,
          },
          tableData: [],
          searchedData: [],
          formatResponse: (data) => {
            let result = [];

            if (data && data[this.caseListData.listQueryTarget] && data[this.caseListData.listQueryTarget].items.length) {
              this.$c.log('formatResponse data', data[this.caseListData.listQueryTarget].items);

              data[this.caseListData.listQueryTarget].items.forEach((item) => {
                item.relateRecordId = item.id;
                item.id = item.case.id;

                if (item.esData) {
                  let esData = JSON.parse(item.esData);
                  if (esData.case) {
                    esData.case.status = (esData.case.status) ? esData.case.status.replace(/_/g, ' ') : "";
                    esData.case.quickNote = esData.case.quickNote ? esData.case.quickNote.substring(0, 30) : '';

                    if (!esData.service && esData.case.services && esData.case.services.items && esData.case.services.items[0]) {
                      let service = esData.case.services.items[0].service;
                      esData.service = {};
                      esData.service.merchantNumber = service.merchantNumber ? service.merchantNumber : '';
                      esData.service.name = service.name ? service.name : '';
                    }

                    if (!esData.case.team) {
                      esData.case.team = {
                        name: ''
                      };
                    }

                    if (!esData.case.template) {
                      esData.case.template = {
                        subject: ''
                      };
                    } else {
                      esData.case.template.subject = esData.case.template.subject.replace(/_/g, ' ');
                    }

                    //ATLAS-1175: <Service><Case tab> Add Closed Date in Hover Menu
                    if (esData.case.closedDate) {
                      let closedDate = moment(esData.case.closedDate).format('MM/DD/YYYY HH:mm:ss');
                      esData.case.closedDate = closedDate;
                    }
                  }
                  item.esData = JSON.stringify(esData);
                }
                result.push(item);
              })
            }
            return result;
          },
          fuseSearch: null,
        },
    };
  },
  methods: {
      async getColumnFilterList () {
          let params = {}, operation;
          operation = graphqlOperation(queries_custom[this.casesList.columnFilter.filterListQueryId], params);
          const result = await API.graphql(operation);
          result.data.listCaseStatusEnum.enumValues.forEach((item) => {
            if (item.name != 'Merged') {
              let filterName = item.name.replace(/_/g, ' ');
              let filterColumnItems = {'label': filterName, 'value': filterName};
              this.casesList.columnFilter.columnFilterList.push(filterColumnItems);
            }
          })
      },
  },
  mounted () { 
    let passMetaData = {
      relateRecordInput: this.caseServiceRelateRecordInput,
      relateRecordInputField: this.caseListData.relateRecordInputField,
      createMutationId: this.caseListData.createMutationId
    }
    this.$router.metaData = passMetaData;
    this.getColumnFilterList();
  }
};
</script>

<style lang="scss">

</style>